/**
 * Table of contents for summary article page template
 */
class SummaryToc {
  constructor() {
    this.el = null
    // this.bodyContent = document.querySelector('.body-content')
    // this.headers = this.bodyContent?.querySelectorAll('h2')
  }

  /**
   * Initialize
   * @param {String} el element of toc
   */
  init(el) {
    if (el) {
      if (document.querySelector(el)) {
        this.el = document.querySelector(el)
        // this.checkContent()
        this.checkLinks()
      }
    }
  }

  checkLinks() {
    this.el.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault()
        document.querySelector(link.getAttribute('href'))?.scrollIntoView({ behavior: 'smooth' })
      })
    })
  }

  /**
   * Check body content for headers (h2)
   */
  // checkContent() {
  //   this.headers.forEach((header) => {
  //     header.setAttribute('id', this.slugify(header.innerText))
  //     this.addToToc(header)
  //   })
  // }

  /**
   * Transform any text to "safe" slug
   * @param {String} string any text to slugify
   * @returns {String} slugified text
   */
  // slugify(string) {
  //   return string
  //     .toLowerCase()
  //     .trim()
  //     .replace(/[^\w\s-]/g, '')
  //     .replace(/[^\w\s-]/g, '')
  //     .replace(/[\s_-]+/g, '-')
  //     .replace(/^-+|-+$/g, '')
  // }

  /**
   * Add link to toc
   * @param {HTMLElement} el Header element to add toc from
   */
  // addToToc(el) {
  //   const tocEl = document.createElement('a')
  //   tocEl.innerHTML = el.innerText
  //   tocEl.setAttribute('href', `#${this.slugify(el.innerText)}`)
  //   tocEl.addEventListener('click', (e) => {
  //     e.preventDefault()
  //     el.scrollIntoView({ behavior: 'smooth' })
  //   })
  //   this.el.append(tocEl)
  //   if (this.headers.length >= 4) {
  //     this.el.classList.add('switch-layout')
  //     if (Array.from(this.headers).indexOf(el) % 2 && Array.from(this.headers).indexOf(el) !== this.headers.length - 1) {
  //       const divider = document.createElement('div')
  //       divider.classList.add('divider')
  //       this.el.append(divider)
  //     }
  //   }
  // }
}

export default new SummaryToc()
